import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SePrinterService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/se-printers', params);
    }

    store(body: any) {
        return super.post(`/se-printers`, body);
    }

    edit(sePrinterId: number) {
        return super.get(`/se-printers/${sePrinterId}/edit`);
    }

    update(sePrinterId: number, body: any) {
        return super.put(`/se-printers/${sePrinterId}`, body);
    }

    destroy(sePrinterId: number) {
        return super.delete(`/se-printers/${sePrinterId}`);
    }

    select(params: any = {}) {
        return super.get(`/se-printers/select`, params);
    }
}
